import axios from 'axios'
import ApplicationController from '../application_controller.js'

/*
 * Encaissements rapides
 */

export default class Widget5Controller extends ApplicationController {

  static targets = [
    "submitButton"
  ]

  connect() {
  }

  disconnect() {
  }

  pay(e) {
    e.preventDefault()
    this.submitButtonTarget.disabled = true

    const form = e.target.closest('form')
    axios.post(form.getAttribute('action'), new FormData(form)).then(response => {
      e.target.closest('tr').innerHTML = ''
      this.notify(response.data)
    }).catch(error => {
      this.submitButtonTarget.disabled = false
      this.alert(error.response.data)
    })
  }

}